import React, { useState, useContext, useEffect } from "react";
import AppContext from '../api/AppContext';

export default function Perfil() {
  const [showComprovanteModal, setShowComprovanteModal] = useState(false);
  const [showFotoModal, setShowFotoModal] = useState(false);
  const [comprovante, setComprovante] = useState(null);
  const [foto, setFoto] = useState(null);
  
  const { user } = useContext(AppContext);
  const dadosAssociado = user?.dadosAssociado;

  // Função para formatar CPF
  const formatCPF = (cpf) => {
    if (!cpf) return '';
    return cpf.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4');
  };

  // Função para formatar telefone
  const formatTelefone = (telefone) => {
    if (!telefone) return '';
    if (telefone.length === 10) {
      return telefone.replace(/(\d{2})(\d{4})(\d{4})/, '($1) $2-$3');
    }
    if (telefone.length === 11) {
      return telefone.replace(/(\d{2})(\d{5})(\d{4})/, '($1) $2-$3');
    }
    return telefone;
  };

  return (
    <div style={styles.container}>
      <div style={styles.card}>
        <h2 style={styles.title}>Perfil</h2>

        {/* Dados Pessoais */}
        <div style={styles.section}>
          <h3 style={styles.sectionTitle}>Dados Pessoais</h3>
          
          <div style={styles.formGroup}>
            <label style={styles.label}>Nome completo</label>
            <input 
              style={styles.input} 
              value={dadosAssociado?.NOME || dadosAssociado?.titular?.nome || user?.name || ''} 
              readOnly 
            />
          </div>

          <div style={styles.formGroup}>
            <label style={styles.label}>Email</label>
            <input 
              style={styles.input} 
              value={dadosAssociado?.EMAIL || dadosAssociado?.titular?.email || user?.email || ''} 
              readOnly 
            />
          </div>

          <div style={styles.formGroup}>
            <label style={styles.label}>CPF</label>
            <input 
              style={styles.input} 
              value={formatCPF(dadosAssociado?.CPF || dadosAssociado?.titular?.cpf || user?.cpf)} 
              readOnly 
            />
          </div>

          <div style={styles.formGroup}>
            <label style={styles.label}>Data de Nascimento</label>
            <input 
              style={styles.input} 
              value={dadosAssociado?.NASCIMENTO ? new Date(dadosAssociado.NASCIMENTO).toLocaleDateString('pt-BR') : 
                    dadosAssociado?.titular?.nascimento ? new Date(dadosAssociado.titular.nascimento).toLocaleDateString('pt-BR') : ''} 
              readOnly 
            />
          </div>

          <div style={styles.formGroup}>
            <label style={styles.label}>Sexo</label>
            <input 
              style={styles.input} 
              value={dadosAssociado?.SEXO ? (dadosAssociado.SEXO.trim() === 'M' ? 'Masculino' : 'Feminino') : ''} 
              readOnly 
            />
          </div>

          <div style={styles.formGroup}>
            <label style={styles.label}>Estado Civil</label>
            <input 
              style={styles.input} 
              value={dadosAssociado?.ESTADOCIVIL || ''} 
              readOnly 
            />
          </div>

          <div style={styles.formGroup}>
            <label style={styles.label}>Profissão</label>
            <input 
              style={styles.input} 
              value={dadosAssociado?.PROFISSAO || ''} 
              readOnly 
            />
          </div>
        </div>

        {/* Contatos */}
        <div style={styles.section}>
          <h3 style={styles.sectionTitle}>Contatos</h3>
          
          <div style={styles.formGroup}>
            <label style={styles.label}>Telefone 1</label>
            <input 
              style={styles.input} 
              value={formatTelefone(dadosAssociado?.FONE1)} 
              readOnly 
            />
          </div>

          <div style={styles.formGroup}>
            <label style={styles.label}>Telefone 2</label>
            <input 
              style={styles.input} 
              value={formatTelefone(dadosAssociado?.FONE2)} 
              readOnly 
            />
          </div>

          <div style={styles.formGroup}>
            <label style={styles.label}>Telefone 3</label>
            <input 
              style={styles.input} 
              value={formatTelefone(dadosAssociado?.FONE3)} 
              readOnly 
            />
          </div>

          <div style={styles.formGroup}>
            <label style={styles.label}>Facebook</label>
            <input 
              style={styles.input} 
              value={dadosAssociado?.FACEBOOK || ''} 
              readOnly 
            />
          </div>
        </div>

        {/* Endereço */}
        <div style={styles.section}>
          <h3 style={styles.sectionTitle}>Endereço</h3>
          
          <div style={styles.formGroup}>
            <label style={styles.label}>CEP</label>
            <input 
              style={styles.input} 
              value={dadosAssociado?.CEP || ''} 
              readOnly 
            />
          </div>

          <div style={styles.formGroup}>
            <label style={styles.label}>Logradouro</label>
            <input 
              style={styles.input} 
              value={dadosAssociado?.LOGRADOURO || ''} 
              readOnly 
            />
          </div>

          <div style={styles.row}>
            <div style={{...styles.formGroup, flex: 1}}>
              <label style={styles.label}>Número</label>
              <input 
                style={styles.input} 
                value={dadosAssociado?.NUMERO || ''} 
                readOnly 
              />
            </div>
            <div style={{...styles.formGroup, flex: 2}}>
              <label style={styles.label}>Complemento</label>
              <input 
                style={styles.input} 
                value={dadosAssociado?.COMPLEMENTO || ''} 
                readOnly 
              />
            </div>
          </div>

          <div style={styles.formGroup}>
            <label style={styles.label}>Bairro</label>
            <input 
              style={styles.input} 
              value={dadosAssociado?.BAIRRO || ''} 
              readOnly 
            />
          </div>

          <div style={styles.row}>
            <div style={{...styles.formGroup, flex: 2}}>
              <label style={styles.label}>Cidade</label>
              <input 
                style={styles.input} 
                value={dadosAssociado?.CIDADE || ''} 
                readOnly 
              />
            </div>
            <div style={{...styles.formGroup, flex: 1}}>
              <label style={styles.label}>UF</label>
              <input 
                style={styles.input} 
                value={dadosAssociado?.UF || ''} 
                readOnly 
              />
            </div>
          </div>
        </div>

        {/* Dados do Associado */}
        <div style={styles.section}>
          <h3 style={styles.sectionTitle}>Dados do Associado</h3>
          
          <div style={styles.formGroup}>
            <label style={styles.label}>Número do Título</label>
            <input 
              style={styles.input} 
              value={dadosAssociado?.numero || dadosAssociado?.TITULO || user?.numeroTitulo || ''} 
              readOnly 
            />
          </div>

          <div style={styles.formGroup}>
            <label style={styles.label}>Situação</label>
            <input 
              style={styles.input} 
              value={dadosAssociado?.adimplente ? 'Adimplente' : 'Inadimplente'} 
              readOnly 
            />
          </div>

          <div style={styles.formGroup}>
            <label style={styles.label}>Status</label>
            <input 
              style={styles.input} 
              value={dadosAssociado?.ATIVO?.trim() === 'S' ? 'Ativo' : 'Inativo'} 
              readOnly 
            />
          </div>

          <div style={styles.formGroup}>
            <label style={styles.label}>Data de Inclusão</label>
            <input 
              style={styles.input} 
              value={dadosAssociado?.INCLUSAO ? new Date(dadosAssociado.INCLUSAO).toLocaleDateString('pt-BR') : ''} 
              readOnly 
            />
          </div>
        </div>

        {/* Ações */}
        <button style={styles.button} onClick={() => setShowComprovanteModal(true)}>
          <span style={styles.icon}>🖼️</span> Alterar comprovante de residência
        </button>

        <button style={styles.button} onClick={() => setShowFotoModal(true)}>
          <span style={styles.icon}>📷</span> Alterar foto
        </button>
      </div>

      {/* MODAIS (mantidos iguais) */}
      {showComprovanteModal && (
        <div style={styles.modalOverlay}>
          <div style={styles.modal}>
            <h3>Enviar comprovante de residência</h3>
            <input
              type="file"
              onChange={(e) => setComprovante(e.target.files[0])}
              style={styles.fileInput}
            />
            <div style={styles.modalButtons}>
              <button style={styles.cancelBtn} onClick={() => setShowComprovanteModal(false)}>
                Cancelar
              </button>
              <button
                style={styles.saveBtn}
                onClick={() => {
                  setShowComprovanteModal(false);
                  alert("Comprovante anexado com sucesso!");
                }}
              >
                Enviar
              </button>
            </div>
          </div>
        </div>
      )}

      {showFotoModal && (
        <div style={styles.modalOverlay}>
          <div style={styles.modal}>
            <h3>Alterar foto</h3>
            <input
              type="file"
              accept="image/*"
              onChange={(e) => setFoto(e.target.files[0])}
              style={styles.fileInput}
            />
            <div style={styles.modalButtons}>
              <button style={styles.cancelBtn} onClick={() => setShowFotoModal(false)}>
                Cancelar
              </button>
              <button
                style={styles.saveBtn}
                onClick={() => {
                  setShowFotoModal(false);
                  alert("Foto alterada com sucesso!");
                }}
              >
                Enviar
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

// ESTILOS ATUALIZADOS
const styles = {
  container: {
    minHeight: "100vh",
    display: "flex",
    justifyContent: "center",
    alignItems: "flex-start",
    backgroundColor: "#eef1ff",
    padding: "20px",
  },
  card: {
    width: "100%",
    maxWidth: "500px",
    backgroundColor: "#f2f4ff",
    borderRadius: "20px",
    padding: "30px 20px",
    boxShadow: "0 4px 10px rgba(0,0,0,0.1)",
    marginBottom: "75px",
  },
  title: {
    textAlign: "center",
    color: "#0a2c6d",
    marginBottom: "25px",
    fontWeight: "700",
  },
  section: {
    marginBottom: "25px",
    paddingBottom: "15px",
    borderBottom: "1px solid #e0e0e0",
  },
  sectionTitle: {
    color: "#0a2c6d",
    fontSize: "16px",
    fontWeight: "600",
    marginBottom: "15px",
  },
  formGroup: {
    marginBottom: "15px",
    display: "flex",
    flexDirection: "column",
    gap: "8px",
  },
  label: {
    fontSize: "14px",
    color: "#333",
    fontWeight: "500",
  },
  input: {
    width: "100%",
    padding: "10px",
    border: "1px solid #ccc",
    borderRadius: "15px",
    outline: "none",
    fontSize: "14px",
    backgroundColor: "#fff",
    color: "#333",
  },
  row: {
    display: "flex",
    gap: "8px",
  },
  button: {
    width: "100%",
    backgroundColor: "white",
    border: "1px solid #ddd",
    borderRadius: "15px",
    padding: "12px",
    marginTop: "12px",
    fontSize: "15px",
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
    gap: "10px",
    transition: "0.3s",
  },
  icon: {
    backgroundColor: "#2e7df6",
    borderRadius: "50%",
    color: "white",
    padding: "8px",
    fontSize: "18px",
  },
  modalOverlay: {
    position: "fixed",
    top: 0,
    left: 0,
    width: "100vw",
    height: "100vh",
    backgroundColor: "rgba(0,0,0,0.4)",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    zIndex: 1000,
  },
  modal: {
    backgroundColor: "white",
    padding: "25px",
    borderRadius: "15px",
    width: "90%",
    maxWidth: "400px",
    boxShadow: "0 5px 20px rgba(0,0,0,0.2)",
    textAlign: "center",
  },
  fileInput: {
    marginTop: "10px",
    marginBottom: "20px",
  },
  modalButtons: {
    display: "flex",
    justifyContent: "space-between",
  },
  cancelBtn: {
    backgroundColor: "#ccc",
    border: "none",
    borderRadius: "10px",
    padding: "10px 20px",
    cursor: "pointer",
  },
  saveBtn: {
    backgroundColor: "#2e7df6",
    border: "none",
    borderRadius: "10px",
    color: "white",
    padding: "10px 20px",
    cursor: "pointer",
  },
};